export const signatureTabsLabels = [
    {
        label: 'Draw',
    },
    {
        label: 'Type',
    },
    {
        label: 'Upload',
    },
];

export const SIGNATURE_ACTION_TYPE = 'APPEND_SIGNATURE_TO_APPMT';

/** Sentinel id of the "+ Other Signer" row in the client-guardian dropdown. */
export const OTHER_SIGNER_OPTION_ID = '__OTHER_SIGNER__';

/**
 * DUPLICATED from `OtherSignerRelationship` / `OtherSignerRelationshipLabels` in
 * `package/src/appt/appt.enums.ts` + `appt.constants.ts`, which back the API's `@IsEnum`.
 * Not importable: the client build emits only `sentry-shared` from @therapylake/package
 * (see MAX_AUTHORIZATION_ID_LENGTH in utils/constants.js). Keep the ids in sync.
 */
export const otherSignerRelationshipOptions = [
    { id: 'TEACHER', name: 'Teacher' },
    { id: 'BABYSITTER', name: 'Babysitter' },
    { id: 'NANNY', name: 'Nanny' },
    { id: 'CAREGIVER', name: 'Caregiver' },
    { id: 'RELATIVE', name: 'Relative' },
    { id: 'OTHER', name: 'Other' },
];

export const EMPTY_OTHER_SIGNER = { name: '', relationship: '' };

/** True when an "Other Signer" form is open but missing its name or role. */
export const isOtherSignerIncomplete = (otherSigner) => !!otherSigner && (!otherSigner.name?.trim() || !otherSigner.relationship);

/** Request fields naming who signed: an ad-hoc other signer, or the selected client contact. */
export const buildSignerPayload = (selectedGuardian, otherSigner) => {
    if (otherSigner) return { otherSigner: { name: otherSigner.name.trim(), relationship: otherSigner.relationship } };
    return selectedGuardian ? { signor: selectedGuardian } : {};
};

